// client/hooks/useAcademyContextEvent.js
import { useEffect } from "react";
import { useAuth } from "../components/ui/AuthContext.jsx";
import { hasAcademyAccess } from "../utils/academyAccess.js";
import { AcademyAPI } from "../constants/academyApi.js";

/** Sendet einmalig ein Academy-Checklist-Event (z. B. visit_dashboard). */
export function useAcademyContextEvent(eventKey) {
  const { hasFeature } = useAuth();
  const allowed = hasAcademyAccess(hasFeature);
  useEffect(() => {
    if (!eventKey || !allowed) return;
    AcademyAPI.event({ event_key: eventKey }).catch(() => {});
  }, [eventKey, allowed]);
}
